import { core } from "@tauri-apps/api";

import { useRoadmapContext } from "../context/useRoadmapContext";
import { type Roadmap_Item } from "../types/roadmap-types";

export const useRoadmapUpdate = () => {
  const { items, setItems } = useRoadmapContext();

  return async (item: Roadmap_Item): Promise<{ success: boolean; error?: string }> => {
    try {
      // Verwende Tauri Command statt Supabase direkt
      await core.invoke("update_roadmap_item", { item });

      // Update local state
      const updatedList = items.map((index) => (index.id === item.id ? item : index));
      setItems(updatedList);

      return { success: true };
    } catch (error) {
      return { error: String(error), success: false };
    }
  };
};
